module.exports = __webpack_public_path__ + "img/logo-etax.de14ba83.png";